// extracted by mini-css-extract-plugin
export default {"table":"LogTable_table__MN52I","title":"LogTable_title__hQeCn"};